import React from 'react';

import { faFile } from '@fortawesome/pro-regular-svg-icons';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';

import FileUpload from '../components/FileUpload';
import axios from '../modules/axios';

export default {
  name: 'documents',
  title: 'Documents',
  icon: faFile,
  resource: 'telechargements',
  primaryKey: 'idtelechargement',
  sort: '-idtelechargement',

  head: {
    online: 'En ligne',
    nom_affichable: 'Nom',
    url_http: 'Fichier',
    type: 'Type',
    downloadable: 'Téléchargable',
    creation: 'Date',
    fourni_par: 'Fourni par',
  },
  list: ({ values }) => [
    <Checkbox checked={values.online} disabled />,
    values.nom_affichable,
    values.url_http && values.url_http.length > 0 ? (
      <a href={values.url_http} target='_blank' rel='noopener noreferrer'>
        Fichier
      </a>
    ) : (
      ''
    ),
    values.type,
    <Grid container spacing={1} direction='row' justifyContent='center' alignItems='center'>
      {values.opti9 && (
        <Grid item xs={6}>
          Opti9
        </Grid>
      )}
      {values.i9 && (
        <Grid item xs={6}>
          i9
        </Grid>
      )}
    </Grid>,
    values.creation,
    values.fourni_par,
  ],
  edit: ({ values, props, setValues, handleChange }) => [
    <FormControlLabel
      control={<Checkbox name='online' checked={values.online} onChange={handleChange} />}
      label='En ligne'
    />,
    <FormControl {...props} fullWidth>
      <InputLabel>Type</InputLabel>
      <Select label='Type' name='type' value={values.type} onChange={handleChange}>
        <MenuItem value='vente'>Vente</MenuItem>
        <MenuItem value='commercial'>Commercial</MenuItem>
      </Select>
    </FormControl>,
    <FormControl component='fieldset'>
      <FormLabel component='legend'>Téléchargeable</FormLabel>
      <FormGroup row>
        <FormControlLabel
          control={<Checkbox name='opti9' checked={values.opti9} onChange={handleChange} />}
          label='Opti9'
        />
        <FormControlLabel control={<Checkbox name='i9' checked={values.i9} onChange={handleChange} />} label='i9' />
      </FormGroup>
    </FormControl>,
    <TextField {...props} fullWidth name='nom_affichable' label='Nom' value={values.nom_affichable} />,
    values.url_http ? (
      <a href={values.url_http} target='_blank' rel='noopener noreferrer'>
        Fichier
      </a>
    ) : null,
    <FileUpload
      resource='telechargements'
      id={values.idtelechargement}
      attribute='url_http'
      uploadFile={async ({ event, id }) => {
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        formData.append('idprog', values.idprog);

        // Will save both to s3 and ftp
        const res = await axios.post(`telechargements/${id}/custom-asset`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        return res;
      }}
      onUpload={changes => {
        setValues({
          ...values,
          ...changes,
        });
      }}
    />,
    <TextField
      {...props}
      fullWidth
      name='creation'
      type='date'
      label='Date création'
      value={values.creation || new Date().toISOString().split('T')[0]}
    />,
    <TextField {...props} fullWidth name='fourni_par' label='Fourni par' value={values.fourni_par} />,
  ],

  add: true,
  popup: true,
  remove: true,
};
